import { render } from "./SocialHint.vue?vue&type=template&id=c2b8e92c"
import script from "./SocialHint.vue?vue&type=script&lang=js"
export * from "./SocialHint.vue?vue&type=script&lang=js"

import "./SocialHint.vue?vue&type=style&index=0&id=c2b8e92c&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__